import "../css/EventsPage.css";
import { lazy, memo, Suspense } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Form from "./Form";
import { useTranslation } from "react-i18next";

const AutoCarousel = lazy(() => import("./carousel"));
const CommonVideoPlayer = lazy(() => import("../common/common-video-player"));

const BANNER_STYLE: React.CSSProperties = {
  backgroundImage: "url('/Vision-Landing.png')",
  minHeight: "400px",
};

const CAROUSEL_ITEMS: { imageUrl: string }[] = [
  { imageUrl: "/SMBF-26.jpg" },
  { imageUrl: "/SMBF-27.jpg" },
  { imageUrl: "/SMBF-28.jpg" },
  { imageUrl: "/SMBF-29.jpg" },
  { imageUrl: "/SMBF-30.jpg" },
  { imageUrl: "/SMBF-31.jpg" },
  { imageUrl: "/SMBF-32.jpg" },
  { imageUrl: "/SMBF-33.jpg" },
  { imageUrl: "/SMBF-34.jpg" },
  { imageUrl: "/SMBF-35.jpg" },
];

const CAROUSEL_SECTION_STYLE: React.CSSProperties = { minHeight: "300px" };
const SUSPENSE_FALLBACK_STYLE: React.CSSProperties = { minHeight: "200px" };
const VIDEO_SUSPENSE_FALLBACK_STYLE: React.CSSProperties = { minHeight: "300px" };
const TESTIMONIALS_SECTION_STYLE: React.CSSProperties = { minHeight: "400px" };
const SUBMIT_BUTTON_STYLE: React.CSSProperties = {
  backgroundColor: "#3899a2",
  border: "1px solid white",
};

function EventsPage() {
  const { t, i18n } = useTranslation();
  const langKey = i18n.resolvedLanguage || i18n.language;
  return (
    <main
      key={langKey}
      className="page-content w-100 pt-5 pt-md-5"
      aria-label={t("events.pageAria")}
    >
      <div
        className="banner py-5 d-flex w-100 flex-column justify-content-between align-items-center"
        style={BANNER_STYLE}
      >
        <div>
          <h1>{t("events.title")}</h1>
          <h4>{t("events.subtitle")}</h4>
        </div>
        <div>
          <h1 className="display-5 fw-semibold px-5">
            {t("events.calendarSoon")}
          </h1>
          <p className="fs-3 fw-semibold">
            {t("events.registerUpdates")}
          </p>
          <div className="d-flex flex-wrap gap-2 justify-content-center mt-4 px-3">
            <Link
              to="/?mode=register"
              className="btn btn-light btn-lg"
            >
              {t("events.registerExplorer")}
            </Link>
          </div>
        </div>
      </div>
      <div className="m-4 border container-bg p-2 p-md-3 rounded-4">
        <Form />
      </div>
      <div className="carousel-bg px-2 pb-5" style={CAROUSEL_SECTION_STYLE}>
        <div className="text-center text-white py-5">
          <h1>{t("events.previousEvents")}</h1>
        </div>
        <Suspense fallback={<div style={SUSPENSE_FALLBACK_STYLE} />}>
          <AutoCarousel items={CAROUSEL_ITEMS} />
        </Suspense>
      </div>
      <div className="container py-4">
        <div className="row gap-4 gap-md-0">
          <div className="col-md-5 d-flex justify-content-center align-items-center">
            <div className="ratio ratio-4x3 w-100 rounded-4 overflow-hidden">
              <img
                className="object-fit-cover"
                src="/SMBF-15.png"
                alt={t("events.imageAlt.eventsSection")}
                width={600}
                height={400}
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
          <div className="col-md-7 d-flex justify-content-center flex-column">
            <h2>{t("events.smbfEventsHeading")}</h2>
            <p>
              {t("events.smbfEventsPara1")}
            </p>
            <p>
              {t("events.smbfEventsPara2")}
            </p>
          </div>
        </div>
      </div>
      <div className="container py-4">
        <div className="row gap-4 gap-md-0">
          <div className="col-md-7 d-flex justify-content-center flex-column">
            <h2>{t("events.networkingDinnersHeading")}</h2>
            <p>
              {t("events.networkingDinnersPara1")}
            </p>
            <p>
              {t("events.networkingDinnersPara2")}
            </p>
          </div>
          <div className="col-md-5 d-flex justify-content-center align-items-center">
            <div className="ratio ratio-4x3 w-100 rounded-4 overflow-hidden">
              <img
                className="object-fit-cover"
                src="/SMBF-WebPic-1.png"
                alt={t("events.imageAlt.networkingSection")}
                width={600}
                height={400}
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="carousel-bg p-3 p-md-5" style={TESTIMONIALS_SECTION_STYLE}>
        <div className="row gap-2 py-md-5 gap-md-0">
          <div className="col-md-4">
            <div className=" text-white d-flex align-items-center justify-content-center h-100">
              <h1 className="display-4 fw-bold">{t("events.testimonials")}</h1>
            </div>
          </div>
          <div className="col-md-4">
            <Suspense fallback={<div style={VIDEO_SUSPENSE_FALLBACK_STYLE} />}>
              <CommonVideoPlayer
                backgroundImage="url(Video-bg-1.png)"
                src="SMBF-video-2.mp4"
              />
            </Suspense>
          </div>
          <div className="col-md-4">
            <Suspense fallback={<div style={VIDEO_SUSPENSE_FALLBACK_STYLE} />}>
              <CommonVideoPlayer
                backgroundImage="url(Video-bg-2.png)"
                src="SMBF-video-1.mp4"
              />
            </Suspense>
          </div>
        </div>
      </div>
      <div className="m-4 border mailing-container-bg p-2 p-md-3 rounded-4">
        <div className="row p-2 py-md-5">
          <div className="col-md-6 px-md-5 px-2 text-white">
            <h1>{t("events.mailingTitle")}</h1>
            <p className="fs-4">{t("events.mailingSubtitle")}</p>
          </div>
          <div className="col-md-6">
            <form
              className="d-flex px-md-5 px-2 flex-column justify-content-center gap-2"
              aria-label={t("events.mailingAria")}
            >
              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control rounded-pill px-4"
                  placeholder={t("common.fullName")}
                  aria-label={t("common.fullName")}
                />
                <input
                  type="email"
                  className="form-control rounded-pill px-4"
                  placeholder={t("common.emailAddress")}
                  aria-label={t("common.emailAddress")}
                />
              </div>
              <Button
                type="submit"
                className="w-100 rounded-pill fw-bold text-white"
                style={SUBMIT_BUTTON_STYLE}
              >
                {t("common.send")}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}

EventsPage.displayName = "EventsPage";

export default memo(EventsPage);
